<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Auto Enrolment Pensions</h1>
    <p>Every employer in the UK must put their eligible employees into a workplace pension and pay into it.</p>
    <p>If you're not sure whether you need an auto-enrolment pension, see <a href="https://www.thepensionsregulator.gov.uk/en/business-advisers/automatic-enrolment-guide-for-business-advisers/duties-for-new-employers#0c42c7b68d394a27a4a54df863203b12">The Pensions Regulator guidance</a> .</p>
    <p>Does your company have an auto enrolment pension?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasAePension ">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasAePension ">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch, onMounted } from 'vue'

const error = ref(null)

const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.hasAePension === undefined || props.formData.hasAePension === null || props.formData.hasAePension === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}



const executeStep = async () => {
  return true;
}




onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>